import api from "./index";

/**
 * Fetch organizations
 * @returns {Promise<Array>}
 */
export async function fetchOrganizations(
    user_id
) {
    const res =
        await api.get(
            "/organizations",
        );

    return (
        res.data
            ?.organizations ??
        []
    );
}

/**
 * Create organization
 */
export async function createOrganization(
    organization_name,
    user_id
) {
    const res =
        await api.post(
            "/organizations/create",
            {
                organization_name,
                user_id,
            }
        );

    return res.data;
}

/**
 * Join organization
 */
export async function joinOrganization(
    invite_code,
    user_id
) {
    const res =
        await api.post(
            "/organizations/join",
            {
                invite_code,
                user_id,
            }
        );

    return res.data;
}

/**
 * Get organization details
 */
export async function getOrganization(
    organization_id,
    user_id
) {
    const res =
        await api.get(
            `/organizations/${organization_id}`,
            {
                params: {
                    user_id,
                },
            }
        );

    return res.data;
}

/**
 * Update shared farms
 */
export async function updateSharedFarms(
    organization_id,
    farm_ids,
    user_id
) {
    const res =
        await api.post(
            `/organizations/${organization_id}/shared-farms`,
            {
                farm_ids,
                user_id,
            }
        );

    return res.data;
}

/**
 * Leave organization
 */
export async function leaveOrganization(
    organization_id,
    user_id
) {
    const res =
        await api.post(
            `/organizations/${organization_id}/leave`,
            {
                user_id,
            }
        );

    return res.data;
}

/**
 * Delete organization
 */
export async function deleteOrganization(
    organization_id,
    user_id
) {
    const res =
        await api.post(
            `/organizations/${organization_id}/delete`,
            {
                user_id,
            }
        );

    return res.data;
}